module.exports = __webpack_public_path__ + "img/Link.6668a4ae.svg";